import { render, staticRenderFns } from "./ComparePatentLoading.vue?vue&type=template&id=69d248b6"
import script from "./ComparePatentLoading.vue?vue&type=script&setup=true&lang=ts"
export * from "./ComparePatentLoading.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports